import { Col, Row } from 'react-bootstrap';
import { formatPrice } from '../../../utils/utils';

const SingleColumnCustomLegend = (props: { colors: any[], series:  ApexAxisChartSeries}) => {
  const series = props.series;
  const colours = props.colors;

  const getLegendItems = () => {
    var items = series.flatMap((item, index) => {
        
      return {
        id: index,
        value: item.data,
        label: item.name,
        colour: colours[index],
      };
    });
    
    return items;
  };
  return (
    <>
      <Row>
        <Col>
          <Row className="text-fs-6 fw-light pt-3 pb-3 lh-xs border-bottom">

            <Col className="text-ligther-grey fw-normal">Compensation</Col>
            <Col className="text-end fw-normal">Amount</Col>

          </Row>
          {getLegendItems().map((item) => (
            <Row
              key={item.id}
              className="text-fs-6 fw-light lh-xs pt-3 pb-3 border-bottom "
            >
              <Col className="pt-1 col-1">
                <div
                  className="custom-legend-marker"
                  style={{
                    backgroundColor: item.colour.toString(),
                  }}
                ></div>
              </Col>
              <Col className="col-8 ps-1">{item.label}</Col>
              <Col className="col-3 text-end">
                {formatPrice(Number(item.value), 'en-US', {
                      currency: 'USD',
                      style: 'currency',
                      minimumFractionDigits: 0,
                    })}
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
    </>
  );
};

export default SingleColumnCustomLegend;
